import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
	return (
		<Wrapper
			className="animate pointer radius8"
			onClick={action ? () => action() : null}
			border={border}
		>
			{title}
		</Wrapper>
	);
}

const Wrapper = styled.button`
	border: 1px solid ${(props) => (props.border ? "#707070" : "#a91d1f")};
	background-color: ${(props) => (props.border ? "transparent" : "#a91d1f")};
	width: 100%;
	padding: 15px;
	outline: none;
	color: ${(props) => (props.border ? "#707070" : "#fff")};
	:hover {
		background-color: ${(props) =>
			props.border ? "transparent" : "#a91d1f"};
		border: 1px solid #a91d1f;
		color: ${(props) => (props.border ? "#a91d1f" : "#fff")};
	}
`;
